import * as React from 'react';
import LoginForm from "../../components/login-form/LoginForm";
import Box from "@mui/material/Box";

function Login() {
    return (
        <Box sx={{
            padding: {xs: "4%", sm: "2%", lg: "1%"},
        }}>
            <LoginForm/>
        </Box>
    );
}

export default Login;